import { gql } from '@apollo/client';
import { TRANSLATED_STRING_FIELDS } from '@assets/i18n/config';

export const FETCH_PORTFOLIO_MODEL_NAME = gql`
  query fetchModelPortfolio($id: ObjectID!) {
    fetchModelPortfolio(input: { modelPortfolioId: $id }) {
      modelPortfolio {
        name
        translatedName { ${TRANSLATED_STRING_FIELDS} }
      }
    }
  }
`;
